export const dashboard: Dashboard = {
    editable: false,
    rowHeight: 350,
    columns: {
        'xxs': 1,
        'xs': 2,
        'sm': 3,
        'md': 4,
        'lg': 4,
    },
    widgets: [{
        module: 'events',
        color: 'events',
        name: 'events.currentEvents',
        ability: {
            action: 'view',
            subject: 'events'
        }
    }, {
        module: 'mails',
        color: 'mails',
        name: 'mails.failedMails',
        ability: {
            action: 'viewAny',
            subject: 'mails'
        }
    }, {
        module: 'myOrganisation',
        color: 'myOrganisation',
        name: 'organisations.organisationStatus',
        ability: {
            action: 'view',
            subject: 'organisations'
        }
    }, {
        module: 'events',
        color: 'events',
        name: 'events.mobileApps',
        ability: {
            action: 'use',
            subject: 'amosweb'
        }
    }],
}